import React, { useState } from "react";

import HeroIntro from "../HomeSectionsComponents/HeroSectionComponents/HeroIntro";
import HeroVideo from "../HomeSectionsComponents/HeroSectionComponents/HeroVideo";
import HeroContent from "../HomeSectionsComponents/HeroSectionComponents/HeroContent";

import "./AmpleHeroSection.css";

const AmpleHeroSection = () => {
  const [showIntro, setShowIntro] = useState(true);

  return (
    <section className="ample-hero-section">

      {/* Intro Screen */}
      {showIntro && (
        <HeroIntro
          onComplete={() => setShowIntro(false)}
        />
      )}

      {/* Main Hero */}
      <HeroVideo>
        <HeroContent />
      </HeroVideo>

    </section>
  );
};

export default AmpleHeroSection;